import { useMemo } from 'react';
import { rage, useObservable } from '~/rage';
import { characterSkillByJob, Job } from '~/shared';

const usePlayerLevel = () => {
	const jobId = useObservable(rage.jobs.getOpenedJobId());

	const skillId = useMemo(
		() => characterSkillByJob[jobId ?? Job.Farmer],
		[jobId],
	);

	const {
		level: playerLevel,
		maxLevel: playerMaxLevel,
		exp,
		maxExp,
	} = useObservable(rage.skills.getSkillLevel(skillId));

	const nextLevel = useMemo(() => {
		return Math.min(playerLevel + 1, playerMaxLevel);
	}, [playerLevel, playerMaxLevel]);

	return { playerLevel, playerMaxLevel, nextLevel, exp, maxExp };
};

export { usePlayerLevel };
